<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import PageHeader from "@/components/page-header";
import treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from '@riophae/vue-treeselect'

const simulateAsyncOperation = fn => {
  setTimeout(fn, 500)
}

export default {
  mixins: [apibtoast, apigeneric],
  page: {
    title: "Web Site Rolleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    treeselect,
  },
  data() {
    return {
      title: this.$t("userroles.Title"),
      items: [
        {
          text: this.$t("userroles.Title"),
          href: "/",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      PageToplu: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },

      website: {},
      KullaniciAra: null,
      BirimAra: null,
      KullaniciYetkiliSiteler: {},
      SiteyeYetkiliKullanicilar: {},
      KullanicilarArray: [],
      BirimArray: [],
      Tab: 1,
      FormData: {},
      websiteArray: [],
      AddEdit: null,
      ComboboxUser: [],
      user: []
    };
  },
  mounted() {
    setTimeout(() => {
      this.showModal = true;
    }, 1500);
  },
  methods: {
    loadOptions({ action,  callback }) {
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {

          const options = this.user;

          callback(null, options)
        })
      }
    },
    user_yukle(veri){
      let Page = {
        PageNumber: "1",
        PageSize: "100",
      };

      if (veri.length>=3){
        this.user=[];
        let Filter="&name="+veri;
      this.ActionsFilterGet({
        Service:
          this.$config.API_ACCOUNT_URL + "Account/get-users",
          Page: Page,
          Filter: Filter,
      }).then((res) => {
        this.ComboboxUser = res.Data;
        for(var i=0; i<this.ComboboxUser.length;i++){
            this.user.push({ id: this.ComboboxUser[i].Id, label: this.ComboboxUser[i].FirstName + " " + this.ComboboxUser[i].LastName })
          }
      });

    }
  },
    Get() {
      this.KullanicilarArray = [];

      this.ActionsGet({
        Service: "website",
        Page: this.PageToplu,
      }).then((res) => {
        this.website = res.Data;
        this.websiteArray = [];
        for (let i = 0; i < res.Data.length; i++) {
          this.websiteArray.push({
            id: res.Data[i].Id,
            label: res.Data[i].Siteadi,
          });
        }
      });


    },

    KullaniciYetkiSorgu(id) {
      this.ActionsFilterGet({
        Service: "userswebsiteyetki",
        Page: this.PageToplu,
        Filter: "&userid=" + id,
      }).then((res) => {
        if (res.Data.length > 0) {
          this.KullaniciYetkiliSiteler = res.Data;
          this.FormData = res.Data[0];
          this.AddEdit = "Edit";
        } else {
          let FormData = {
            Userid: id,
            Websiteids: [],
          };
          this.AddEdit = "Add";
          this.FormData = FormData;
        }
      });
    },
    YetkiKullaniciSorgu(id) {
      this.ActionsFilterGet({
        Service: "userswebsiteyetki",
        Page: this.PageToplu,
        Filter: "&Websiteids=" + id,
      }).then((res) => {
        if (res) {
          this.SiteyeYetkiliKullanicilar = res.Data;
        }
      });
    },
    onSubmit() {
      if (this.AddEdit == "Add") {
        this.Post("userswebsiteyetki", this.FormData).then((res) => {
          if (res) {
            this.AddEdit = "Edit";
            this.FormData.Id = res;
          }
        });
      } else {
        this.Update("userswebsiteyetki", this.FormData);
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader title="" :items="items" />
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="card-body">
            <h5 class="h4 card-title">
              {{ $t("userroles.page.yetkiislemleri") }}
            </h5>
            <p class="card-title-desc">
              {{
                $t(
                  "userroles.page.kullanicilaricinyetkinedirmeveyetkilistelemeekrani"
                )
              }}
            </p>

            <b-tabs
              justified
              nav-class="nav-tabs-custom"
              content-class="p-3 text-muted"
            >
              <b-tab active @click="Tab = 1">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{
                    $t("userroles.page.kullaniciyetkilendirme")
                  }}</span>
                </template>

                <div class="mx-5">
                  <h4 class="card-title">
                    {{ $t("userroles.page.kullaniciara") }}
                  </h4>
                  <p class="card-title-desc">
                    {{
                      $t(
                        "userroles.page.yetkilendirmekistediginizkullaniciyiseciniz"
                      )
                    }}
                  </p>
                  <b-form-group class="col-lg-12" id="example text" label-for="text">
                      <treeselect 
                      @search-change="user_yukle($event)"
                      :async="true"
                      :load-options="loadOptions"
                      :multiple="false" 
                      searchPromptText="Aramak için yazın..."
                      placeholder="Seçiniz..." 
                      name="KullaniciAra"
                      v-model="KullaniciAra" 
                      @select="KullaniciYetkiSorgu($event.id)"
                                
                      />
                      <treeselect-value :value="KullaniciAra" />
                    </b-form-group>
                </div>
              </b-tab>

              <b-tab @click="Tab = 2">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{
                    $t("userroles.page.websitelistele")
                  }}</span>
                </template>

                <div class="mx-5">
                  <h4 class="card-title">
                    {{ $t("userroles.page.websiteler") }}
                  </h4>
                  <p class="card-title-desc">
                    {{
                      $t(
                        "userroles.page.websitelerinebaglikullanicilarigormekcinsecimyapin"
                      )
                    }}
                  </p>
                  <div class="col-lg-12">
                    <treeselect
                      :multiple="false"
                      :options="websiteArray"
                      placeholder="Seçiniz..."
                      @select="YetkiKullaniciSorgu($event.id)"
                    />
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12" v-if="KullaniciAra && Tab == 1">
      <div class="card">
        <div class="card-body">
          <h5 class="h4 card-title">
            {{ this.$t("userroles.page.kullaniciyetkilendirmeekrani") }}
          </h5>
          <p class="card-title-desc">
            {{ this.$t("userroles.page.ekampusicin") }}
            {{ this.$t("userroles.page.yetkilendirmeekrani") }}
          </p>
          <div class="row">
            <div class="col-md-10">
              <treeselect
                multiple="true"
                :options="websiteArray"
                :placeholder="$t('OrtakKullanim.seciniz')"
                v-model="FormData.Websiteids"
              />
            </div>
            <div class="col-md-2">
              <button class="btn btn-primary" @click="onSubmit()">
                {{ $t("userroles.page.Button") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12" v-if="Tab == 2">
      <div class="card">
        <div class="card-body">
          <h5 class="h4 card-title">
            {{ $t("userroles.page.yetkilikullanicilar") }}
          </h5>
          <p class="card-title-desc">
            {{ $t("userroles.page.listelenenyetki") }}
            {{ $t("userroles.page.yetkilikullanicilar") }}
          </p>

          <div class="table-responsive">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col">{{ $t("userroles.table.FirstName") }}</th>
                  <th scope="col">{{ $t("userroles.table.LastName") }}</th>
                  <th scope="col">{{ $t("userroles.table.Email") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(Kullanici, index) in SiteyeYetkiliKullanicilar"
                  :key="index"
                >
                  <td>{{ Kullanici.Adi }}</td>
                  <td>{{ Kullanici.Soyadi }}</td>
                  <td>{{ Kullanici.Mail }}</td>
                </tr>
              </tbody>
            </table>
            <b-pagination
              class="pagination pagination-rounded justify-content-end mb-2"
              v-model="DefaultPage"
              :total-rows="Page.PageDataSize"
              :per-page="Page.PageSize"
              aria-controls="my-table"
              @input="ChangePage(DefaultPage)"
            >
            </b-pagination>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
